import { render, staticRenderFns } from "./NewsCarousel.vue?vue&type=template&id=29d4345e&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"
import style0 from "./NewsCarousel.vue?vue&type=style&index=0&id=29d4345e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4345e",
  null
  
)

export default component.exports